import React,{useEffect,useState} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomFilter from "../../../constants/CustomFilter";
import CustomTransposeMatrix from "./CustomTransposeMatrix";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Paper'
import {getCourseOutcomeData,getorganizationData,getCourseCurriculumData,getTermsData,getBloomsLevelData,getCourseData,getProgramOutcomeData,getCurriculumData} from "../../../redux/actions/dataAction";
import {connect} from 'react-redux';

const TransposeProgramArticulationMatrix = (props) => {
	useEffect(()=>{

    props.getCourseCurriculumData()
    props.getorganizationData();
    props.getProgramOutcomeData();
    props.getCurriculumData();
    props.getCourseData()
    props.getTermsData()
    props.getCourseOutcomeData()
    props.getBloomsLevelData();

  },[])
  	const [filterCourseData,setFilterCourseData]=useState([]);
  	const [filter,setFilter]=useState({
    		curriculum:'Select Curriculum',
   	})
  	const handleChange=(event)=>{
    	setFilter({...filter,[event.target.id]:event.target.value}) 
  	}
  	const curriculums=[]
	for(var i=0;i<props?.curriculums?.data.length;i++){
  		curriculums.push({value:props?.curriculums?.data[i].name})
	}

  return (
    <div className={'customContainer'}>
      <CustomHeading title="Transpose Program Articulation Matrix" />
     <div className="row">
      <div className="col-md-12">
    	<CustomDropdown 
      	label="Curriculum :"
      	data={curriculums}
      	defaultOption={'Select Curriculum'}
      	notDefaultOption
      	id={'curriculum'}
      	onChange={handleChange}
      	/>
      </div>
    </div>
    {props?.programOutcome!=undefined?<CustomTransposeMatrix data={props?.programOutcome!=undefined?CustomFilter(props?.programOutcome?.data,[{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]):''} 
     />
   	:''}
    </div>
  );
};
const mapActionWithProps = {
  getCourseOutcomeData,
  getCourseCurriculumData,
  getTermsData,
  getCurriculumData,
  getorganizationData,
  getProgramOutcomeData,
  getBloomsLevelData,
  getCourseData
}

const mapStateWithProps = (state)=>(
  {
    courseOutcome:state.data.courseOutcome,
    course_curriculum:state.data.course_curriculum,
    terms:state.data.terms,
    curriculums:state.data.curriculums,
    organization:state.data.organisation,
    programOutcome:state.data.programOutcome,
    bloomLevel:state.data.bloomLevel,
    course:state.data.course
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (TransposeProgramArticulationMatrix);